import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

import { TOKENS } from "../lib/designTokens";

export const RouteMap = ({ points, highlightPoints, compact = false }) => {
  const mapRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || !points || points.length === 0) return;

    if (!mapRef.current) {
      mapRef.current = L.map(containerRef.current, {
        zoomControl: true,
        attributionControl: true,
      }).setView([points[0][0], points[0][1]], 14);

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 19,
        attribution: "© OpenStreetMap",
      }).addTo(mapRef.current);
    }

    const layers = [];

    const baseLine = L.polyline(points, {
      color: highlightPoints?.length > 1 ? TOKENS.analytics.amber : TOKENS.analytics.blue,
      weight: highlightPoints?.length > 1 ? 4 : 3,
      opacity: highlightPoints?.length > 1 ? 0.45 : 0.9,
    }).addTo(mapRef.current);
    layers.push(baseLine);

    if (highlightPoints?.length > 1) {
      const highlightLine = L.polyline(highlightPoints, {
        color: TOKENS.analytics.blue,
        weight: 5,
        opacity: 1,
      }).addTo(mapRef.current);
      layers.push(highlightLine);
    }

    const startIcon = L.divIcon({
      className: "",
      html: `<div style="width:12px;height:12px;background:${TOKENS.analytics.green};border:2px solid var(--app-background);box-shadow:0 0 0 2px ${TOKENS.analytics.green};"></div>`,
    });
    const endIcon = L.divIcon({
      className: "",
      html: `<div style="width:12px;height:12px;background:${TOKENS.analytics.red};border:2px solid var(--app-background);box-shadow:0 0 0 2px ${TOKENS.analytics.red};"></div>`,
    });
    const startMk = L.marker(points[0], { icon: startIcon }).addTo(mapRef.current);
    const endMk = L.marker(points[points.length - 1], { icon: endIcon }).addTo(mapRef.current);
    layers.push(startMk, endMk);

    if (highlightPoints?.length > 1) {
      const lapStartMk = L.marker(highlightPoints[0], { icon: startIcon }).addTo(mapRef.current);
      layers.push(lapStartMk);
    }

    const boundsPoints =
      highlightPoints?.length > 1 ? highlightPoints : points;
    const boundsLine = L.polyline(boundsPoints);
    mapRef.current.fitBounds(boundsLine.getBounds(), { padding: [30, 30] });

    return () => {
      layers.forEach((l) => l.remove());
    };
  }, [points, highlightPoints]);

  useEffect(() => {
    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, []);

  return (
    <div className="app-card overflow-hidden h-full flex flex-col" data-testid="route-map-container">
      {!compact && (
        <div className="px-5 py-4 border-b border-[var(--border-primary)]">
          <div className="card-label">GPS Trace</div>
          <h3 className="section-title mt-0.5">Route</h3>
        </div>
      )}
      <div
        ref={containerRef}
        className={`flex-1 w-full ${compact ? "min-h-[160px]" : "min-h-[280px]"}`}
      />
    </div>
  );
};
